export default "__VITE_PUBLIC_ASSET__6fdbc30a__"